import React from 'react'
import PurpleBtn from '../components/btns/PurpleBtn'
import { useNavigate } from 'react-router-dom';

const ResultPage = () => {
    const navigate = useNavigate();

    const backHome = () => {
        navigate('/')
    }
  return (
    <div className='container w-full h-screen'>
        <div className='flex justify-center items-center w-full h-screen '>
            <div className='flex flex-col gap-4'>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Ad Soyad / Qeydiyyat Nişanı: Rustam Gasanov</p>
                </div>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Film: Joker</p>
                </div>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Mərkəz: Su İdman Sarayı</p>
                </div>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Saat: 19:00</p>
                </div>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Tarix: 20.10.2024</p>
                </div>
                <div className='border border-purple px-4 py-1 flex justify-center gap-2 items-center rounded-[20px] w-[400px]'>
                    <p className='text-purple font-semibold'>Ödəniş: 20 AZN</p>
                </div>
                <div className='flex justify-center mt-4'>
                <PurpleBtn onClick={backHome} title={'Qayıt'}/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ResultPage